var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.47461C3.89543 3.47461 3 4.37004 3 5.47461V18.4746C3 19.5792 3.89543 20.4746 5 20.4746H19C20.1046 20.4746 21 19.5792 21 18.4746V5.47461C21 4.37004 20.1046 3.47461 19 3.47461H5ZM15.75 16.201C15.75 16.6428 16.1082 17.001 16.55 17.001H17.45C17.8918 17.001 18.25 16.6428 18.25 16.201V10.801C18.25 10.3591 17.8918 10.001 17.45 10.001H16.55C16.1082 10.001 15.75 10.3591 15.75 10.801V16.201ZM11.55 17.001C11.1082 17.001 10.75 16.6428 10.75 16.201L10.75 8.80098C10.75 8.35915 11.1082 8.00098 11.55 8.00098H12.45C12.8918 8.00098 13.25 8.35915 13.25 8.80098V16.201C13.25 16.6428 12.8918 17.001 12.45 17.001H11.55ZM5.75 16.201C5.75 16.6428 6.10817 17.001 6.55 17.001H7.45C7.89183 17.001 8.25 16.6428 8.25 16.201L8.25 12.801C8.25 12.3591 7.89183 12.001 7.45 12.001H6.55C6.10817 12.001 5.75 12.3591 5.75 12.801L5.75 16.201Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsIcon);
export default __webpack_public_path__ + "static/media/Bars Icon.547a7661914809a7dddee824b4a049e8.svg";
export { ForwardRef as ReactComponent };